(function () {
  'use strict';
  var observer;
  var observerTimer;
  function normalizeSize(value) {
    var size = String(value || '').trim().toLowerCase().replace(/\s*\(.*/, '').replace(/\s*:\s*.*/, '').replace(/\s+-\s+\d.*$/, '').replace(/\s+/g, ' ').trim();
    if (/^short queen\b/.test(size)) return 'short queen';
    if (/^rv king\b/.test(size)) return 'rv king';
    if (/^(ca|cal|cal\.) king$/.test(size)) return 'california king';
    if (/^split (ca|cal|cal\.) king$/.test(size)) return 'split california king';
    return size;
  }
  function money(cents) { return '$' + (Number(cents || 0) / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}); }
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function variantFor(card, size) {
    var match = null;
    String(card.getAttribute('data-tx-size-prices') || '').split('||').forEach(function (record) {
      var p = record.split('~');
      if (normalizeSize(p[0]) !== size || Number(p[1]) <= 0) return;
      var v = {size:p[0],price:Number(p[1]),compare:Number(p[2] || 0),available:p[3] !== 'false',id:p[4] || ''};
      if (!match || (v.available && !match.available) || (v.available === match.available && v.price < match.price)) match = v;
    });
    return match;
  }
  function cache(node, attribute, value) { if (node && !node.hasAttribute(attribute)) node.setAttribute(attribute, value); }
  function updateCard(card, size) {
    var price = card.querySelector('.tx-mattress-starting-price');
    if (!price) return;
    var payment = card.querySelector('.tx-mattress-card__payment strong');
    var savings = card.querySelector('.tx-mattress-card__savings');
    var cta = card.querySelector('.tx-mattress-card__cta');
    var shortlist = card.querySelector('[data-tx-shortlist-toggle]');
    cache(price, 'data-tx-original-html', price.innerHTML);
    cache(payment, 'data-tx-original-html', payment ? payment.innerHTML : '');
    cache(savings, 'data-tx-original-html', savings ? savings.innerHTML : '');
    cache(cta, 'data-tx-original-label', cta ? cta.textContent : '');
    cache(cta, 'data-tx-original-href', cta ? cta.getAttribute('href') : '');
    if (!size) {
      [price,payment,savings].forEach(function (node) { if (node && node.innerHTML !== node.getAttribute('data-tx-original-html')) node.innerHTML = node.getAttribute('data-tx-original-html'); });
      if (savings) savings.hidden = false;
      if (cta) { text(cta, cta.getAttribute('data-tx-original-label')); cta.setAttribute('href', cta.getAttribute('data-tx-original-href')); }
      return;
    }
    var v = variantFor(card, size);
    if (!v) return;
    text(price.querySelector('.tx-mattress-starting-price__label'), 'Starting at · ' + v.size + (v.available ? '' : ' · currently unavailable'));
    text(price.querySelector('.money'), money(v.price));
    text(payment, money(Math.round(v.price / 48)) + '/mo');
    if (savings) { savings.hidden = v.compare <= v.price; if (!savings.hidden) text(savings, 'Save ' + money(v.compare - v.price)); }
    if (cta) {
      text(cta, v.available ? 'View mattress →' : 'View availability →');
      var url = new URL(cta.getAttribute('data-tx-original-href'), location.origin);
      if (v.id) url.searchParams.set('variant', v.id);
      cta.setAttribute('href', url.pathname + url.search + url.hash);
    }
    if (shortlist) { shortlist.dataset.txComparePrice = String(v.price); if (v.id) shortlist.dataset.txCompareVariant = v.id; }
  }
  function apply() {
    var tools = document.querySelector('[data-tx-collection-tools]');
    if (!tools) return;
    var rawSize = new URLSearchParams(location.search).get('tx_size') || '';
    var size = normalizeSize(rawSize);
    var isRv = tools.hasAttribute('data-tx-rv-collection');
    if (isRv && size !== 'short queen' && size !== 'rv king') size = 'short queen';
    var rvVariants = {};
    if (isRv) { try { rvVariants = JSON.parse(tools.querySelector('[data-tx-rv-variants]').textContent); } catch (error) {} }
    var visible = 0;
    document.querySelectorAll('[data-tx-sizes]').forEach(function (card) {
      var match = !size || String(card.getAttribute('data-tx-sizes') || '').split('|').map(normalizeSize).indexOf(size) >= 0;
      card.hidden = !match;
      updateCard(card, size);
      if (isRv && match) {
        var options = {};
        try { options = JSON.parse(card.getAttribute('data-product-options') || '{}'); } catch (error) {}
        var variants = (rvVariants[options.handle] || []).filter(function (v) { return normalizeSize(v.option1) === size; }).sort(function (a,b) { return a.price - b.price; });
        if (variants[0]) card.querySelectorAll('a[href*="/products/"]').forEach(function (link) { var url = new URL(link.href); url.searchParams.set('variant', variants[0].id); link.href = url.toString(); });
      }
      if (match) visible += 1;
    });
    document.querySelectorAll('[data-tx-size-link]').forEach(function (link) { var active = normalizeSize(link.getAttribute('data-size')) === size; link.classList.toggle('is-active',active); if (active) link.setAttribute('aria-current','page'); else link.removeAttribute('aria-current'); });
    text(document.querySelector('[data-tx-size-status]'), visible + ' matching mattress' + (visible === 1 ? '' : 'es') + ' shown on this page.');
    document.querySelectorAll('a[href]').forEach(function (link) { if (size && /page=/.test(link.href) && link.href.includes('/collections/')) { var url = new URL(link.href); url.searchParams.set('tx_size', rawSize); link.href = url.toString(); } });
  }
  function bind() {
    if (!document.querySelector('[data-tx-collection-tools]')) return;
    apply();
    if (window.__txShoppingPersonalizationBind) window.__txShoppingPersonalizationBind();
    if (!observer) {
      observer = new MutationObserver(function () { clearTimeout(observerTimer); observerTimer = setTimeout(bind,120); });
      var grid = document.querySelector('#tx-mattress-products, [data-contentlm-replace], .t4s-products');
      if (grid) observer.observe(grid,{childList:true});
    }
  }
  document.addEventListener('DOMContentLoaded',bind);
  document.addEventListener('shopify:section:load',bind);
  if (document.readyState !== 'loading') bind();
}());
